import React from 'react';
// import Menu from '../../components/menu';
import Nav from '../../components/nav';
import ContactComponent from '../../components/contact';
import Footer from '../../components/footer';
import "./styles_contact.css";
import "./reset.css";

function Contact() {
  return (
    <div className='App'>
      <div className='fondoImg'></div>
      <div className='fondo'></div>
      <div className='fondo2'></div>
      <div className='fondo3'></div>
      <Nav/>
      {/* <Menu/> */}
      <ContactComponent/>
      <hr style={{marginTop: '50px', height: '10px', backgroundColor: '#848688'}} />
      <Footer/>
    </div>
  );
}

// Actualizamos el nombre de la exportación
export default Contact;
